import {dbOperacao} from '../lib/model'

export class Settings {
    // dados recuperados a cada tela para reavaliar se ainda esta logado e
    // informações sobre o recurso acessado e permissões do usuário logado 
    // sobre este recurso
    public Logado: boolean = false;
    public Mensagem: string = ""; 

    // variaveis de controle para o formulario
    public showForm: boolean = false;    
    public change: boolean = false;
    public modoEdicao: string = "";  
    public operacao: dbOperacao = dbOperacao.Nenhum;
    public backButtonText: string = "Voltar";

    public hiddenComponents: Array<boolean>;

    constructor(_hiddenComponents: Array<boolean> = null) {
        this.hiddenComponents = _hiddenComponents;
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/config/settings.ts
 **/